import { render, staticRenderFns } from "./RealtimeCard.vue?vue&type=template&id=3bc779ff&"
import script from "./RealtimeCard.vue?vue&type=script&lang=ts&"
export * from "./RealtimeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports